import { render, staticRenderFns } from "./GiroAccountForm.vue?vue&type=template&id=6d08f823&"
import script from "./GiroAccountForm.vue?vue&type=script&lang=ts&"
export * from "./GiroAccountForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports